import React, { useState, useEffect, useContext } from "react";
import CryptoJS from "crypto-js";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Link,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SavingsIcon from "@mui/icons-material/Savings";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useMediaQuery } from "@mui/material";
import { ContextSession } from "../../services/ContextSession";

const Cotizaciones = () => {
  let sessi = useContext(ContextSession);
  const isMobile = useMediaQuery("(max-width:820px)");
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogSalarios, setOpenDialogSalarios] = useState(false);
  const [datos, setDatos] = useState({
    salarios: [],
    promedioSalarios: "Cargando...",
    saldoCotizado: "Cargando...",
    pensionAproximada: "Cargando...",
  });

  const [loading, setLoading] = useState(true);
  const [dni, setDni] = useState("");
  const [usuario, setUsuario] = useState("");

  const useFront =
    "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
  useEffect(() => {
    // Cargar valores desde localStorage o desde el contexto
    const storedDni =
      sessionStorage.getItem("dni") || sessi.sessionData.identidad;
    //   sessi.getVariable("dni");
    const storedUsuario =
      sessionStorage.getItem("usuario") || sessi.sessionData.usuario;
    //   sessi.getVariable("Usuario");
    setDni(storedDni);
    setUsuario(storedUsuario);

    // Guardar en localStorage
    sessionStorage.setItem("dni", storedDni);
    // sessi.setVariable("dni", storedDni);
    sessionStorage.setItem("usuario", storedUsuario);
    // sessi.setVariable("usuario", storedUsuario);
  }, [sessi.sessionData]);

  const queryString = `DNI=${dni}&usuario=${usuario}`;
  //const queryString = `DNI=0801199620949&usuario=${usuario}`;
  //const queryString = `DNI=0801198304254&usuario=${usuario}`;
  const signature = CryptoJS.HmacSHA256(queryString, useFront).toString(
    CryptoJS.enc.Hex
  );

  const fetchApiData = async (url, key) => {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "X-Signature": signature,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error(`Error en la API: ${key}`);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error(`Error obteniendo datos de ${key}:`, error);
      return { error: true };
    }
  };

  useEffect(() => {
    if (!dni || !usuario) return; // Evitar llamadas con valores vacíos

    setLoading(true);
    fetchApiData(
      `${sessi.ip}/api/Consultas/SaldoCotizados/?${queryString}`,
      "saldoCotizado"
    )
      .then((data) => {
        setDatos((prev) => ({
          ...prev,
          saldoCotizado: data?.error
            ? "Información no encontrada"
            : data.saldo || 0,
        }));
      })
      .finally(() => setLoading(false));
  }, [dni, usuario]);

  useEffect(() => {
    if (!dni || !usuario) return;

    fetchApiData(
      `${sessi.ip}/api/Consultas/PromedioSalarios/?${queryString}`,
      "promedioSalarios"
    ).then((data) => {
      setDatos((prev) => ({
        ...prev,
        promedioSalarios: data?.error ? "Sin Cálculo" : data.PromSalario06 || 0,
      }));
    });
  }, [dni, usuario]);

  useEffect(() => {
    if (!dni || !usuario) return;

    fetchApiData(
      `${sessi.ip}/api/Consultas/PensionAproximada/?${queryString}`,
      "pensionAproximada"
    ).then((data) => {
      if (
        data?.error ||
        data.PensionAproximada ===
          "No cuenta con los datos necesarios para el cálculo."
      ) {
        setDatos((prev) => ({
          ...prev,
          pensionAproximada: "Sin Cálculo",
          showPensionMessage: true,
        }));
      } else {
        setDatos((prev) => ({
          ...prev,
          pensionAproximada: data.PensionAproximada || 0,
          showPensionMessage: false,
        }));
      }
    });
  }, [dni, usuario]);

  useEffect(() => {
    if (!dni || !usuario) return;

    fetchApiData(
      `${sessi.ip}/api/Consultas/UltimosSalariosCotizados/?${queryString}`,
      "ultimosSalarios"
    ).then((data) => {
      if (data?.error) {
        setDatos((prev) => ({ ...prev, salarios: [] }));
      } else {
        const salariosTransformados = data.Resultado.map((item) => {
          const salario = item;
          return { /*mes: fecha, */ salario: parseFloat(salario) || 0 };
        });
        setDatos((prev) => ({ ...prev, salarios: salariosTransformados }));
      }
    });
  }, [dni, usuario]);

  const formatCurrency = (value) => {
    if (typeof value === "number") {
      return `L. ${value.toLocaleString("es-HN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }
    return value; // Si es texto, lo deja igual (ej: "Información no encontrada")
  };

  return (
    <Container maxWidth="md">
      <Grid item marginTop={isMobile ? 0 : 3}>
        <h1 style={{ textAlign: "center" }}>Cotizaciones</h1>
      </Grid>

      <Grid container spacing={3} justifyContent="center">
        {[
          {
            icon: <TrendingUpIcon sx={{ fontSize: 40, color: "#19438C" }} />,
            title: "Promedio Salarios:",
            value: datos.promedioSalarios,
          },
          {
            icon: <SavingsIcon sx={{ fontSize: 40, color: "#388e3c" }} />,
            title: "Saldo Cotizado:",
            value: datos.saldoCotizado,
          },
          {
            icon: <TrendingUpIcon sx={{ fontSize: 40, color: "#fbc02d" }} />,
            title: "Pensión Aproximada (Mensual):",
            value: datos.pensionAproximada,
          },
        ].map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 2,
                boxShadow: 3,
                borderRadius: 2,
                backgroundColor: "#c0ddf1",
                height: "100%",
              }}
            >
              {item.icon}
              <CardContent sx={{ textAlign: "center", height: "100%" }}>
                <Typography variant="subtitle2">{item.title}</Typography>
                <Typography variant="h6">
                  {formatCurrency(item.value)}
                </Typography>
                {index === 2 && datos.showPensionMessage && (
                  <Link
                    component="button"
                    variant="body2"
                    onClick={() => setOpenDialog(true)}
                    sx={{ color: "#19438C" }} // Cambia el color aquí
                  >
                    Pulsa aquí para mayor detalle
                  </Link>
                )}
                {index === 0 && datos.showPensionMessage && (
                  <Link
                    component="button"
                    variant="body2"
                    onClick={() => setOpenDialogSalarios(true)}
                    sx={{ color: "#19438C" }} // Cambia el color aquí
                  >
                    Pulsa aquí para mayor detalle
                  </Link>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom align="center">
            Últimos Salarios Cotizados:
          </Typography>
          {loading ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              mt={2}
            >
              <CircularProgress />
              <Typography variant="body1" sx={{ mt: 1 }}>
                Obteniendo últimos salarios cotizados...
              </Typography>
            </Box>
          ) : datos.salarios.length > 0 ? (
            <TableContainer component={Paper} elevation={3}>
              <Table>
                <TableHead>
                  <TableRow>
                    {/*<TableCell sx={{ backgroundColor: "#89CFE0", fontWeight: "bold", textAlign: "center", color: 'white' }}>Mes</TableCell>*/}
                    <TableCell
                      sx={{
                        backgroundColor: "#19438C",
                        fontWeight: "bold",
                        textAlign: "center",
                        color: "white",
                      }}
                    >
                      #
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "#19438C",
                        fontWeight: "bold",
                        textAlign: "center",
                        color: "white",
                      }}
                    >
                      Salario (L.)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {datos.salarios.map((item, index) => (
                    <TableRow key={index}>
                      {/*<TableCell sx={{ textAlign: "center" }}>{item.mes}</TableCell>*/}
                      <TableCell sx={{ textAlign: "center" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {formatCurrency(item.salario)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              mt={2}
            >
              <CircularProgress />
              <Typography variant="body1" sx={{ mt: 1 }}>
                Obteniendo últimos salarios cotizados...
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle sx={{ textAlign: "center" }}>
          Información sobre la Pensión Aproximada
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ textAlign: "justify" }}>
            Para calcular su pensión aproximada, es requisito haber cotizado un
            mínimo de 36 meses. Para mayor información consulte con nuestros
            agentes de call center llamando al +504 2290-1900.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            sx={{
              backgroundColor: "#19438C", // Mismo color del link
              color: "white",
              borderRadius: "20px",
              "&:hover": { backgroundColor: "#19438C" }, // Color más oscuro al pasar el mouse
            }}
          >
            Cerrar
          </Button>{" "}
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDialogSalarios}
        onClose={() => setOpenDialogSalarios(false)}
      >
        <DialogTitle sx={{ textAlign: "center" }}>
          Información sobre el Promedio de Salarios
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ textAlign: "justify" }}>
            Para calcular su promedio de salarios, es requisito haber cotizado
            un mínimo de 36 meses. Para mayor información consulte con nuestros
            agentes de call center llamando al +504 2290-1900.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            onClick={() => setOpenDialogSalarios(false)}
            variant="contained"
            sx={{
              backgroundColor: "#19438C", // Mismo color del link
              color: "white",
              borderRadius: "20px",
              "&:hover": { backgroundColor: "#19438C" }, // Color más oscuro al pasar el mouse
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Cotizaciones;

//0801198304254
/*import React, { useState, useEffect, useContext } from "react";
import CryptoJS from "crypto-js";
import {
    Container, Grid, Card, CardContent, Typography, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, Link
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SavingsIcon from "@mui/icons-material/Savings";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useMediaQuery } from "@mui/material";
import { ContextSession } from "../../services/ContextSession";

const Cotizaciones = () => {
    let sessi = useContext(ContextSession);
    const isMobile = useMediaQuery("(max-width:820px)");
    const [openDialog, setOpenDialog] = useState(false);
    const [datos, setDatos] = useState({
        salarios: [],
        promedioSalarios: "Cargando...",
        saldoCotizado: "Cargando...",
        pensionAproximada: "Cargando...",
    });

    const [loading, setLoading] = useState(true);
    const dni = sessi.sessionData.identidad;
    const usuario = sessi.sessionData.usuario;
    const secretKey = "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
    const queryString = `DNI=${dni}&usuario=${usuario}`;
    const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(CryptoJS.enc.Hex);

    const fetchApiData = async (url, key) => {
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "X-Signature": signature,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) throw new Error(`Error en la API: ${key}`);

            const data = await response.json();
            return data;
        } catch (error) {
            console.error(`Error obteniendo datos de ${key}:`, error);
            return { error: true };
        }
    };

    useEffect(() => {
        setLoading(true);
        fetchApiData(`${sessi.ip}/api/Consultas/SaldoCotizados/?${queryString}`, "saldoCotizado")
            .then(data => {
                setDatos(prev => ({
                    ...prev,
                    saldoCotizado: data?.error ? "Información no encontrada" : data.saldo || 0,
                }));
            })
            .finally(() => setLoading(false));
    }, [dni, usuario]);

    useEffect(() => {
        fetchApiData(`${sessi.ip}/api/Consultas/PromedioSalarios/?${queryString}`, "promedioSalarios")
            .then(data => {
                setDatos(prev => ({
                    ...prev,
                    promedioSalarios: data?.error ? "Información no encontrada" : data.PromSalario06 || 0,
                }));
            });
    }, [dni, usuario]);

    useEffect(() => {
        fetchApiData(`${sessi.ip}/api/Consultas/PensionAproximada/?${queryString}`, "pensionAproximada")
            .then(data => {
                if (data?.error || data.PensionAproximada === "No cuenta con los datos necesarios para el cálculo.") {
                    setDatos(prev => ({
                        ...prev,
                        pensionAproximada: "Sin Cálculo",
                        showPensionMessage: true
                    }));
                } else {
                    setDatos(prev => ({
                        ...prev,
                        pensionAproximada: data.PensionAproximada || 0,
                        showPensionMessage: false
                    }));
                }
            });
    }, [dni, usuario]);


    useEffect(() => {
        fetchApiData(`${sessi.ip}/api/Consultas/UltimosSalariosCotizados/?${queryString}`, "ultimosSalarios")
            .then(data => {
                if (data?.error) {
                    setDatos(prev => ({ ...prev, salarios: [] }));
                } else {
                    const salariosTransformados = data.Resultado.map(item => {
                        const [fecha, salario] = item.split(" - ");
                        return { mes: fecha, salario: parseFloat(salario) || 0 };
                    });
                    setDatos(prev => ({ ...prev, salarios: salariosTransformados }));
                }
            });
    }, [dni, usuario]);

    const formatCurrency = (value) => {
        if (typeof value === "number") {
            return `L. ${value.toLocaleString("es-HN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        return value; // Si es texto, lo deja igual (ej: "Información no encontrada")
    };

    return (
        <Container maxWidth="md">
            <Grid item marginTop={isMobile ? 0 : 3}>
                <h1 style={{ textAlign: "center" }}>Cotizaciones</h1>
            </Grid>

            <Grid container spacing={3} justifyContent="center">
                {[
                    { icon: <TrendingUpIcon sx={{ fontSize: 40, color: "#1976d2" }} />, title: "Promedio Salarios:", value: datos.promedioSalarios },
                    { icon: <SavingsIcon sx={{ fontSize: 40, color: "#388e3c" }} />, title: "Saldo Cotizado:", value: datos.saldoCotizado },
                    { icon: <TrendingUpIcon sx={{ fontSize: 40, color: "#fbc02d" }} />, title: "Pensión Aproximada:", value: datos.pensionAproximada },
                ].map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", p: 2, boxShadow: 3, borderRadius: 2, backgroundColor: "#E3F2FD", height: "100%" }}>
                            {item.icon}
                            <CardContent sx={{ textAlign: "center", height: "100%" }}>
                                <Typography variant="subtitle2">{item.title}</Typography>
                                <Typography variant="h6">{formatCurrency(item.value)}</Typography>
                                {index === 2 && datos.showPensionMessage && (
                                    <Link
                                        component="button"
                                        variant="body2"
                                        onClick={() => setOpenDialog(true)}
                                        sx={{ color: "#d32f2f" }} // Cambia el color aquí
                                    >
                                        Pulsa aquí para mayor detalle
                                    </Link>

                                )}
                            </CardContent>
                        </Card>

                    </Grid>
                ))}

                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom align="center">
                        Últimos Salarios Cotizados:
                    </Typography>
                    {loading ? (
                        <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
                            <CircularProgress />
                            <Typography variant="body1" sx={{ mt: 1 }}>Obteniendo últimos salarios cotizados...</Typography>
                        </Box>
                    ) : datos.salarios.length > 0 ? (
                        <TableContainer component={Paper} elevation={3}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ backgroundColor: "#89CFE0", fontWeight: "bold", textAlign: "center", color: 'white' }}>Mes</TableCell>
                                        <TableCell sx={{ backgroundColor: "#89CFE0", fontWeight: "bold", textAlign: "center", color: 'white' }}>Salario (L.)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {datos.salarios.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ textAlign: "center" }}>{item.mes}</TableCell>
                                            <TableCell sx={{ textAlign: "center" }}>{formatCurrency(item.salario)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
                            <CircularProgress />
                            <Typography variant="body1" sx={{ mt: 1 }}>Obteniendo últimos salarios cotizados...</Typography>
                        </Box>
                    )}
                </Grid>
            </Grid>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle sx={{ textAlign: "center" }}>
                    Información sobre la Pensión Aproximada
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ textAlign: "justify" }}>
                        Para calcular su pensión aproximada, es requisito haber cotizado un mínimo de 36 meses. Consulte con nuestros agentes de call center llamando al +504 2290-1900, opción #3.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                    <Button
                        onClick={() => setOpenDialog(false)}
                        variant="contained"
                        sx={{
                            backgroundColor: "#d32f2f", // Mismo color del link
                            color: "white",
                            borderRadius: "20px",
                            "&:hover": { backgroundColor: "#89CFE0" } // Color más oscuro al pasar el mouse
                        }}
                    >
                        Cerrar
                    </Button>    </DialogActions>
            </Dialog>

        </Container>
    );
};

export default Cotizaciones;
*/
